import { SelectStyleInterface } from './select-style.interface';
import { SelectDarkTheme } from './select.dark-theme';

export const SelectLightTheme: SelectStyleInterface = SelectDarkTheme;
